webpackJsonp([68145893269697],{

/***/ 947:
/***/ (function(module, exports) {

	module.exports = {"data":{"cardsJson":{"starting_zone":"codex","mid_text_1":null,"sirlins_filename":"0035_cursed_crow.jpg","type":"Unit","subtype":"Bird","cost":3,"ATK":3,"HP":3,"rules_text_1":"Flying","rules_text_2":"Damages a base: Defending player discards a card at random.","rules_text_3":null,"base_text_1":null,"base_text_2":null,"ATK_1":null,"HP_1":null,"mid_level":null,"name":"Cursed Crow","mid_text_2":null,"ATK_2":null,"HP_2":null,"max_level":null,"max_text_1":null,"max_text_2":null,"ATK_3":null,"HP_3":null,"flavor_text":null,"color":"Black","spec":"Disease","bottom":"Tech II","rulings":[{"ruling":"It has to damage the base directly to get the effect. Destroying a building and causing its owner to take 2 damage doesn't count.","date":"2016-03-19T07:00:00.000Z","author":"Sirlin"}],"keywords":["Flying"],"slug":"cursed_crow"},"site":{"siteMetadata":{"title":"Codex Card Database"}}},"pathContext":{"slug":"cursed_crow","keywords":["Flying"],"imageRegex":"/cursed_crow.jpg/"}}

/***/ })

});


// WEBPACK FOOTER //
// path---card-cursed-crow-4b7e2c937f73df23dc74.js